"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../http");
var Message_1 = require("../Message");
var constants_1 = require("../constants");
/**
 * An Auction Result event is sent when the auction ends, and we have determined which
 * bid is the winning bid.
 * in:
 *   adUnitId: the id on the div that this ad is going to render in
 *   bestBid: the bid object for the best bid from the auction
 *   bids: all the bids that were received
 * out:
 *   this function returns a UUID for the event that was sent
 * side effects:
 *   none
 * notes:
 *   similarly to the bid request, the requestId is loaded based on the adPartner in the ads cache and
 *   there is potential for that to be overwritten if things execute unexpectedly. The impact of that
 *   happening are fairly minimal though.
 */
var sendAuctionResult = function (adUnitId, bestBid, bids) {
    var page = window.ads[adUnitId]["page"];
    var storyId = window.ads[adUnitId]["story_id"];
    var partId = window.ads[adUnitId]["part_id"];
    var adPartner = window.ads[adUnitId]["ad_partner"];
    var requestOffset = Date.now() - window.ads[adUnitId][constants_1.startTimeField];
    var message = (0, Message_1.getCommonMessageFields)(page, storyId, partId);
    // auction_result specific fields
    message.ad_partner = adPartner;
    message.page_view_id = window.ads.page_view_id;
    message.request_id = window.ads[adUnitId][adPartner + "_request"];
    message.adunit_id = adUnitId;
    message.num_bids = bids ? bids === null || bids === void 0 ? void 0 : bids.length : 0;
    message.price = bestBid ? bestBid === null || bestBid === void 0 ? void 0 : bestBid.bic : 0;
    message.best_bid_id = bestBid ? bestBid === null || bestBid === void 0 ? void 0 : bestBid.id : null;
    message.request_offset = requestOffset;
    (0, http_1.sendAthaEvent)("auction_result", message);
    return message.id;
};
exports.default = sendAuctionResult;
